/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FoldersControllerFindOneQueryResponse, FoldersControllerFindOnePathParams, FoldersControllerFindOneQueryParams, FoldersControllerFindOne400, FoldersControllerFindOne401, FoldersControllerFindOne403, FoldersControllerFindOne404 } from "../../models/foldersController/FoldersControllerFindOne";

function getFoldersControllerFindOneUrl(id: FoldersControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/folders/${id}` as const }  
  return res
}

/**
 * @summary Get folder by id
 * {@link /api/v1/folders/:id}
 */
export async function foldersControllerFindOne(id: FoldersControllerFindOnePathParams["id"], params?: FoldersControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FoldersControllerFindOneQueryResponse, ResponseErrorConfig<FoldersControllerFindOne400 | FoldersControllerFindOne401 | FoldersControllerFindOne403 | FoldersControllerFindOne404>, unknown>({ method : "GET", url : getFoldersControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}